import { Aspect } from '@teambit/harmony';

export const ExpressAspect = Aspect.create({
  id: 'teambit.harmony/express',
  dependencies: [],
  defaultConfig: {},
});
